<script>
    export let data, click;
</script>
<li data-filter="members-{data.id}" data-id="{data.id}" class="member-group" class:active={data.active}>
    <a rel="action" data-action="showMemberGroup" on:click={() => click(data)}>
        <span>{data.name}</span>
        <span data-role="filter-count">{data.count || ''}</span>
    </a>
</li>